import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';
import { AnnuityType } from '../annuities/dto/annuity-type';
import { AnnuityPensionAnnuityTypeIdEnum } from '../enum/shared/annuity-pension-annuity-type-id.enum';
import { AnnuityGuaranteePeriodType } from '../shared/annuity-guarantee-period-type';
import { AnnuityGuaranteePeriodTypeId } from '../annuities/enum/annuity-guarantee-period-type';
import { AnnuityPensionAccountPaymentInstruction } from './annuity-pension-account-payment-instruction';
import { AnnuityPensionAccountNote } from './annuity-pension-account-note';
import { StatusPill } from '../shared/status-pill';
import { AnnuityAccountStateTypeEnum } from './enum/annuity-account-state-type.enum';

export class AnnuityPensionAccountDetails implements Deserializable {
  public accountId!: number;
  public annuityTypeId!: AnnuityPensionAnnuityTypeIdEnum;
  public annuityType!: AnnuityType;
  public annuityGuaranteePeriodId!: AnnuityGuaranteePeriodTypeId;
  public annuityGuaranteePeriod!: AnnuityGuaranteePeriodType;
  public stateId!: AnnuityAccountStateTypeEnum;
  public state!: BaseType;
  public isSplit!: boolean;
  public effectiveDate!: string;
  public nextPaymentDate!: string | null; // TODO: Remove this property if needed, SPP-2999
  public guaranteeEndDate!: string | null;
  public jointPensionerId!: number | null;
  public jointPensionerName!: string | null;
  public purchasePrice!: number;
  public annuityConversionRate!: number;
  public monthlyBenefit!: number;
  public ownerCurrentMonthlyAmount!: number | null;
  public survivorBenefit!: number | null;
  public paidToDate!: number;
  public lastPaymentDate!: string | null;
  public lastPaymentAmount!: number | null;
  public canEngageJointLifeSurvivorship!: boolean;
  public paymentInstructions!: AnnuityPensionAccountPaymentInstruction[];
  public notes!: AnnuityPensionAccountNote[];

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.annuityType) {
      this.annuityType = Deserialize.instanceOf(AnnuityType, this.annuityType);
    }

    if (this.annuityGuaranteePeriod) {
      this.annuityGuaranteePeriod = Deserialize.instanceOf(AnnuityGuaranteePeriodType, this.annuityGuaranteePeriod);
    }

    if (this.state) {
      this.state = Deserialize.instanceOf(BaseType, this.state);
    }

    if (this.paymentInstructions?.length) {
      this.paymentInstructions = Deserialize.arrayOf(AnnuityPensionAccountPaymentInstruction, this.paymentInstructions);
    }

    if (this.notes?.length) {
      this.notes = Deserialize.arrayOf(AnnuityPensionAccountNote, this.notes);
    }
  }

  public getSplitStatusPill(): StatusPill | null {
    return this.isSplit ? new StatusPill(0, $localize`Split`, '#C97DC9', '#FADCFA', '#5E0F5E', '#C97DC9') : null;
  }
}
